import {ChoiceValue} from "data/models/survey/choice-base";
import {MultiSelectValue} from "data/models/survey/multi-choice";
import {SingleSelectValue} from "data/models/survey/single-choice";


export type ChoiceValueMap = { [key: string]: string };


export function choiceValueMap(choices: ChoiceValue[]): ChoiceValueMap {
  return choices.reduce((result, choice) => ({
    ...result,
    [choice.key]: choice.value
  }), {});
}

export function choiceValuesFromKeys(choiceKeys: string[], choiceValueMap: ChoiceValueMap): ChoiceValue[] {
  return choiceKeys.map(choiceKey => ({
    key: choiceKey,
    value: choiceValueMap[choiceKey],
  }));
}

export function multiSelectValues(value: MultiSelectValue | undefined): string[] | undefined {
  if (value === undefined || value.choice === undefined) {
    return undefined;
  }
  return [...(value.choice.values ?? []), ...(value.choice.other ? [value.choice.other] : [])]
}

export function singleSelectValue(value: SingleSelectValue | undefined): string | undefined {
  if (value === undefined) {
    return undefined;
  }
  return value.value ?? value.other;
}
